import { render, staticRenderFns } from "./ProfileGenericProfileImage.vue?vue&type=template&id=001916ca"
import script from "./ProfileGenericProfileImage.vue?vue&type=script&lang=js"
export * from "./ProfileGenericProfileImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports